import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Conferencing, Copy } from '@/components/Icon';
import { Button } from '@/components/UI/Button';
import { Flex } from '@/layout';
import { H4 } from '@/components/UI/Typography/Heading';

import { createMeetingId } from '@/api/event.api';
import useCurrentLang from '@/hooks/useCurrentLang';
import { dmpMeetingFailure } from '@/utils/dmpMeeting';
import { errorHandler, successHandler } from '@/utils/toastHandler';
import { Text } from '@/components/UI/Typography/Text';

const Wrapper = styled.div`
  width: 100%;
  padding: 140px 0;
  max-width: 930px;
  background: ${(p) => p.theme.colors.light};
  border-radius: 15px 15px 0 0;
`;

const LinkWrapper = styled.div`
  width: min(425px, 100%);
  padding-bottom: 10px;
  border-bottom: 2px solid ${(p) => p.theme.colors.gray100};
  display: flex;
  justify-content: space-between;
  cursor: pointer;
`;

const VideoConferencingForm = () => {
  // @ts-ignore
  const { t } = useTranslation();
  const lang = useCurrentLang();

  const [link, setLink] = useState('');
  const [busy, setBusy] = useState(false);

  const handleGenerateLink = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const meetingId = await createMeetingId();
      setLink(`${window.location.origin}/event/joinMeeting?meetingID=${encodeURIComponent(meetingId)}`);
    } catch (error) {
      errorHandler(dmpMeetingFailure(error, lang === 'en'));
    } finally { setBusy(false); }
  };

  const handleCopyLink = () => {
    if (!link) return errorHandler('Please generate meeting link first');
    navigator.clipboard.writeText(link);
    successHandler(t('success.copied'));
  };

  return (
    <Wrapper>
      <Flex flexDirection={'column'} alignItems={'center'} justifyContent={'center'}>
        <Conferencing.ConferencingSVG />
        {link ? (
          <Text textAlign={'center'} marginBottom={24}>
            You can copy this link and send it to the meeting invitee.<br/>Be sure to save the link for future use.
          </Text>
        ) : (
          <Button type="button" disabled={busy} onClick={handleGenerateLink} size={'lg'} variant={'primary-invert'} rounded={false} marginBottom={24}>
            Create Meeting Link
          </Button>
        )}
        <LinkWrapper onClick={handleCopyLink}>
          <H4 style={{ width: 'calc(100% - 24px)', wordBreak: 'break-all' }}>{link}</H4>
          <Copy.CopySVG fill={'#3C5AB1'} />
        </LinkWrapper>
      </Flex>
    </Wrapper>
  );
};
export default VideoConferencingForm;
